import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../../../utils/axiosInterceptor';
import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';

import {
    Paper, Typography, Button, Container, Fab, Tooltip,
    Dialog, DialogActions, DialogContent, DialogTitle,
    Table, TableHead, TableBody, TableRow, TableCell,
    FormControl, TextField, Box, Divider, Grid, Autocomplete,
    Checkbox, FormGroup, FormControlLabel, Accordion, AccordionSummary, AccordionDetails,
    Card,
} from '@mui/material';

import CustomMessage from '../../../utils/components/CustomMessage';
import CustomStatusChip from '../../../utils/components/CustomStatusChip';
import CustomChip from '../../../utils/components/CustomChip';
import { formatMoney } from '../../../utils/functions/Utils';

const Config = () => {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [data, setData] = useState([]);
    const [configs, setConfigs] = useState({});

    const [costoDesign, setCostoDesign] = useState(0);
    const [costoEmbalaje, setCostoEmbajale] = useState(0);
    const [costoNomina, setCostoNomina] = useState(0);

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    useEffect(() => {
        if (!['Admin', 'Vendedor', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Cotizador';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const getData = async () => {
        try {
            let res = await axios.get(`/api/configs/company/${auth.user.company}`);
            if (res.status === 200) {
                setConfigs(res.data);
                setCostoDesign(res.data.priceData.costoDesign)
                setCostoEmbajale(res.data.priceData.embalaje.precioUnitario)
                setCostoNomina(res.data.priceData.nomina.manoObraMin)
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getData()
    }, [])


    return (
        <Box>
            <Divider sx={{ my: 3 }} textAlign="center">
                <CustomChip variant='outlined' estatus='ATENDIDO' label='Costos' className='text-bold' />
            </Divider>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                        <TextField
                            label='Costo de Diseño'
                            size='small'
                            value={costoDesign}
                            onChange={(e) => setCostoDesign(e.target.value)}
                            variant='outlined'
                            error={isNaN(Number(costoDesign)) ? true : false} helperText={isNaN(Number(costoDesign)) ? 'El costo debe ser un número' : `$ ${formatMoney(costoDesign)}`}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                        <TextField
                            label='Embalaje: Caja estandar, hule espuma, cinta'
                            size='small'
                            value={costoEmbalaje}
                            onChange={(e) => setCostoEmbajale(e.target.value)}
                            variant='outlined'
                            error={isNaN(Number(costoEmbalaje)) ? true : false} helperText={isNaN(Number(costoEmbalaje)) ? 'El costo debe ser un número' : `$ ${formatMoney(costoEmbalaje)}`}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                        <TextField
                            label='Nomina (precio x minuto)'
                            size='small'
                            value={costoNomina}
                            onChange={(e) => setCostoNomina(e.target.value)}
                            variant='outlined'
                            error={isNaN(Number(costoNomina)) ? true : false} helperText={isNaN(Number(costoNomina)) ? 'El costo debe ser un número' : `$ ${formatMoney(costoNomina)}`}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Divider sx={{ my: 3 }} textAlign="center">
                <CustomChip variant='outlined' estatus='ATENDIDO' label='Materiales' className='text-bold' />
            </Divider>
            <Grid container spacing={3}>
                {configs?.priceData?.materiales?.map((item, i) => {
                    return (
                        <Grid item xs={12} md={4} lg={3} key={i + 'ada'}>
                            <CardItem item={item} />
                        </Grid>
                    )
                })}
            </Grid>
            <Divider sx={{ my: 3 }} textAlign="center">
                <CustomChip variant='outlined' estatus='ATENDIDO' label='Maquinas' className='text-bold' />
            </Divider>
        </Box>
    )
}

function CardItem(props) {
    return (
        <Box sx={{ minWidth: 100, display: 'flex', alignItems: 'stretch', flexDirection: 'row', height: '100%' }}>
            <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '20px', width: '100%', justifyContent: 'end' }} elevation={3}>
                <div>
                    <Box className='mb-2' sx={{ color: 'secondary.main' }}>
                        <i className='fad fa-cubes fa-2x'></i>
                    </Box>
                </div>
                <div>
                    <Typography style={{ fontWeight: 700 }} variant="h5" component="div">
                        {props.item.nombre}
                    </Typography>
                    <Typography variant="h6" className='p-1'>
                        $ {formatMoney(props.item.costo)}
                    </Typography>
                    <Typography variant="body1" className='text-bold'>
                        {props.item.tipo}
                    </Typography>
                    <Typography variant="body2">
                        $ {formatMoney(props.item.precioUnitario)} x {props.item.unidad}
                    </Typography>
                    <Typography variant="caption">
                        {props.item.factorMerma} (factor de merma)
                    </Typography>
                </div>
                <Divider variant="middle" className='my-1' sx={{ width: '100%' }} />
                <div>
                    {/* <CardActions style={{ display: 'flex', justifyContent: 'center' }}>
                <Link to={props.to} style={{ textDecoration: 'none' }}>
                    <Button color={props.btnColor ? props.btnColor : 'secondary'} variant='outlined'>{props.button} &nbsp; {props.buttonIco ? <i className={props.buttonIco}></i> : <i className="fad fa-arrow-circle-right"></i>}</Button>
                </Link>
                </CardActions> */}
                </div>
            </Card>
        </Box>
    )
}

export default Config;